import { ModalFooter, ModalFooterProps } from '@chakra-ui/react';

export type DialogFooterProps = ModalFooterProps;

const DialogFooter = (props: DialogFooterProps) => {
  return <ModalFooter {...props} />;
};

export default DialogFooter;
